import React, { useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { makeStyles, Button, Paper, FormControl } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { createNotification, getSchema, uiSchema, getWhitelist } from './utils';
import JSForm from '../../Form';
import LoadingCard from '../../UI/LoadingCard';

const useStyles = makeStyles(theme => ({
  paper: {
    maxWidth: '50%',
    margin: 'auto',
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(6))]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3)
    },
    [theme.breakpoints.down(600 + theme.spacing(6))]: {
      maxWidth: '100%'
    }
  },
  button: {
    marginTop: 16
  },
  dropArea: {
    width: '100%',
    borderWidth: 2,
    borderStyle: 'dashed',
    borderColor: theme.palette.primary.main,
    marginTop: 16,
    padding: 16,
    marginBottom: 8,
    textAlign: 'center'
  },
  dragIn: {
    opacity: 0.5
  },
  uploadBtn: {
    fontSize: '4em'
  },
  searchLabel: {
    cursor: 'pointer',
    color: theme.palette.primary.main,
    display: 'inline-block'
  },
  uploadedIcon: {
    opacity: 0.7,
    fontSize: '2.5em',
    marginRight: 16,
    verticalAlign: 'middle'
  },
  formControl: {
    position: 'relative',
    width: '100%',
    marginTop: 16,
    marginBottom: 8
  },
  hiddenFileInput: {
    opacity: 0,
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  }
}));

const CreateCertifiedNotification = ({ config }) => {
  const { activeContext, extraConfig } = config;
  const { t } = useTranslation();
  const [state, setState] = useState({});
  const history = useHistory();
  const classes = useStyles();
  const ctxExtraConfig = useMemo(() => JSON.parse(activeContext.extraConfig.data), [activeContext]);
  const whitelist = useMemo(() => {
    const appExtraConfig = JSON.parse(extraConfig.data);
    return getWhitelist(state.type, appExtraConfig, ctxExtraConfig);
  }, [state.type]);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  function onSubmit ({ formData }) {
    setLoading(true);
    createNotification(formData)
      .then(() => history.push('/notification'))
      .catch((err) => {
        const error = err.response.data.errors.map((error) => error.cause.map((cause) => t(`certificate:error:${cause}`)).join(', ')).join(' ');
        setError(error || 'Ha ocurrido un error');
        setLoading(false);
      });
  }

  return (
    <Paper className={classes.paper}>
      <LoadingCard open={loading} loading message={t('certificate:createForm:sending')} />
      {error && (
        <Alert severity='error' onClose={() => setError(null)}>
          {error}
        </Alert>
      )}
      <JSForm
        schema={getSchema(whitelist, ctxExtraConfig.emailSignature)}
        uiSchema={uiSchema}
        onSubmit={onSubmit}
        formData={state}
        onChange={({ formData }) => setState(formData)}
      >
        <FormControl className={classes.formControl}>
          <Button variant='outlined' color='primary' onClick={() => history.goBack()}>
            {t('alertDialog:cancel')}
          </Button>
          <Button variant='contained' type='submit' color='primary' disabled={loading} className={classes.button}>
            {t('alertDialog:accept')}
          </Button>
        </FormControl>
      </JSForm>
    </Paper>
  );
};

const mapStateToProps = (state) => {
  return {
    config: state.config
  };
};

CreateCertifiedNotification.propTypes = {
  config: PropTypes.object.isRequired
};

export default connect(mapStateToProps)(CreateCertifiedNotification);
